import { Switch } from "react-router-dom";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "core/resources/enums/permissao";
import EquipamentosListaPage from "./Listagem/index";

function EquipamentosPages() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/administracao/patrimonio"
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Equipamento.Atualizar,
        ]}
        component={EquipamentosListaPage}
      />
    </Switch>
  );
}

export default EquipamentosPages;
